export default class AutomationSmsCtrl {
    constructor($scope, $filter, $stateParams, $state, $q, SideMenu, Setting, Events, Automation, SmsService, StringUtils) {
        SideMenu.setActive('automation');

        this._scope = $scope;
        this._filter = $filter;
        this._stateParams = $stateParams;
        this._state = $state;
        this._q = $q;

        this.smsService = SmsService;
        this.stringUtils = StringUtils;
        this.settingRepo = Setting;
        this.eventsHandler = Events;
        this.automationRepo = Automation;

        this.displayList = [];
        this.automail = {
            id: this._stateParams.id
        };

        this.automationRepo.find(this._stateParams.id).then((automation) => {
            this.automail.active = automation.data.active;
        });

        this.settingRepo.findSenderDetail().then((details) => {
            if (this._state.current.name == "automation.smsCreate") {
                this.smsService.setTextMessage({
                    from_name: details.text_message_sender_name || details.name || "",
                    subject: '',
                    content: '',
                    contentNotTrimmed: '',
                    language: 'sv'
                });
            }

            this.smsService.setStopMessage(details.text_message_stop);
        });

        if (this._state.current.name == "automation.smsEdit" && this._stateParams.textMessageId) {
            this.automationRepo.findTextMessage(this._stateParams.id, this._stateParams.textMessageId).then((message) => {
                this.smsService.setTextMessage({
                    id: message.data.id,
                    from_name: message.data.from_name,
                    language: message.data.language.data.code,
                    subject: message.data.subject
                });

                this.automationRepo.textMessageContent(this._stateParams.id, this._stateParams.textMessageId).then((content) => {
                    this.smsService.setTextMessage({
                        content: this.stringUtils.trimWithLeaveTrailNewline(content.content.replace('%TextMessage:Stop%', ''))
                    });
                });

                this.getHistory();
            });
        }

        this._scope.$on("historyContentSelect", (event, contentId) => {
            this.getHistoryContent(contentId);
        });

        this._scope.$on('account:changed', () => {
            this._state.go('automation.index');
        });
    }

    toIndex() {
        this._state.go('automation.folder', { folder: this.automail.active ? 'active' : 'inactive' });
    };

    getHistory() {
        this.automationRepo.getTextMessageHistoryMeta(this._stateParams.id, this._stateParams.textMessageId)
            .then((displayList) => {
                this.historySelect = displayList.data[0].id;
                this.historyMeta = displayList.data;
            });
    };

    trimSenderLength() {
        var sender = this.smsService.textMessage.from_name;

        if (sender.length > 11) {
            this.smsService.textMessage.from_name = sender.slice(0, 11 - sender.length);
        }
    };

    validSender() {
        this.errorMessage = 'CAMPAIGN:FLASH:INVALID_SENDER';

        let regexCustomField = /\[CustomField:(.*?)\.(.*?)\]/;

        return this.smsService.textMessage.from_name &&
            this.smsService.textMessage.from_name.length > 0 &&
            (this.smsService.textMessage.from_name.length <= 11 ||
                regexCustomField.test(this.smsService.textMessage.from_name));
    };

    validDraft() {
        return this.validSender() && this.smsService.validSMS();
    };

    handleCreateSuccess(response) {
        this.smsService.setTextMessage(response.data);
        this.eventsHandler.flashEvent('notification', this._filter('translate')('AUTOMATION:FLASH:CREATED'));
        this._state.go('automation.smsEdit', { id: this.automail.id, textMessageId: this.smsService.textMessage.id });

        // this.deferred.resolve();
    };

    handleSaveSuccess() {
        this.eventsHandler.flashEvent('notification', this._filter('translate')('AUTOMATION:FLASH:TEXT_SAVED'));

            // this.deferred.resolve();
        };

    handleSaveError(error) {
        if (error.status == 400) {
            this.eventsHandler.flashEvent('error', this._filter('translate')('AUTOMATION:FLASH:INVALID_SMS'));
        } else {
            this.eventsHandler.flashEvent('error', this._filter('translate')('AUTOMATION:FLASH:FAIL_SMS'));
        }

        // this.deferred.reject();
    };

    getHistoryContent(contentId) {
        this.automationRepo.getTextMessageHistoryContent(contentId).then((response) => {
            this.smsService.setTextMessage({content: response.content});
        });
    };

    onSave(){
        if (this.validDraft()) {
            this.save();
        } else {
            this.eventsHandler.flashEvent('error', this._filter('translate')(this.errorMessage));
        }
    };

    save() {
        if (this.validDraft()) {
            // var deferred = this._q.defer();
            // var bindScope = { deferred: deferred };
            this.smsService.textMessage.content = this.stringUtils.trimWithLeaveTrailNewline((this.smsService.textMessage.content));
            this.smsService.textMessage.contentNotTrimmed = this.smsService.textMessage.content;

            if (this._state.current.name == "automation.smsEdit") {
                this.automationRepo.saveTextMessage(this._stateParams.id, this.smsService.textMessage)
                    .then(() => {
                        this.handleSaveSuccess();
                    }, (error) => {
                        this.handleSaveError(error);
                    });
            } else {
                this.automationRepo.createTextMessage(this._stateParams.id, this.smsService.textMessage)
                    .then((response) => {
                        this.handleCreateSuccess(response);
                    }, (error) => {
                        this.handleSaveError(error);
                    });
            }
        }
    };
}
